<template>
  <div class="mobile-header-container">
    <header>
      <div class="logo">
        <img v-if="logoBigUrl" :src="logoBigUrl" alt="logo" class="logo-big" />
      </div>
      <div class="buttons">
        <div id="helpButton" ref="helpButton">
          <button v-if="!isMenuOpen && !isHelpOpen" @click="toggleHelp">
            <IllustrationsMenuButtonHelpOff />
          </button>
          <button v-if="!isMenuOpen && isHelpOpen" @click="toggleHelp">
            <IllustrationsMenuButtonHelpOn />
          </button>
        </div>
        <button
          v-if="sessionStore.isLoggedIn"
          class="hamburger"
          @click="toggleMenu"
        >
          <IconsHamburger v-if="!isMenuOpen" />
          <IconsClose v-else />
        </button>
      </div>
    </header>
    <div v-if="isMenuOpen" id="dropdown-menu">
      <SelfcareMenu :is-mobile="true" @click="toggleMenu" />
    </div>
    <div v-if="isHelpOpen" id="helpPopup">
      <div ref="helpPopup">
        <IconsClose class="close" @click="toggleHelp" />
        <AskForHelp />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useBrandingStore } from "~/stores/branding";
import { useSessionStore } from "~/stores/session";

defineProps({
  hide: {
    type: Boolean,
    default: false,
  },
});

const isMenuOpen = ref(false);
const isHelpOpen = ref(false);
const brandingStore = useBrandingStore();
const sessionStore = useSessionStore();

const logoBigUrl = computed(() => brandingStore.logoBigUrl);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  isHelpOpen.value = false;
};

const toggleHelp = () => {
  isHelpOpen.value = !isHelpOpen.value;
};

watch(isMenuOpen, (open) => {
  if (process.client) {
    document.body.style.overflow = open ? "hidden" : "";
  }
});

onBeforeUnmount(() => {
  if (process.client) {
    document.body.style.overflow = "";
  }
});
</script>

<style scoped lang="scss">
header {
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  min-height: 56px;
  height: 56px;
  max-height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);

  .logo {
    max-width: 176px;
    max-height: 44px;
  }

  .logo-big {
    max-width: 176px;
    max-height: 44px;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;

    button {
      background: none;
      border: none;
      margin: 0;
      padding: 0;

      &.hamburger {
        padding: 8px;
      }
    }
  }
}

#dropdown-menu {
  display: flex;
  background: white;
  padding: 16px;
  flex: 1;
  z-index: 100;
  position: fixed;
  inset: 56px 0 0 0;
  overflow: hidden;
  // 100vh is the *large* mobile viewport (address bar collapsed), so it keeps
  // recalculating - and this panel's height with it - as the address bar
  // shows/hides during a scroll gesture inside the menu. dvh tracks the
  // actual visible viewport instead; the vh rule stays as a fallback for
  // browsers without dvh support.
  height: calc(100vh - 56px);
  height: calc(100dvh - 56px);
  max-height: calc(100vh - 56px);
  max-height: calc(100dvh - 56px);
}

#helpButton {
  display: flex;
}

#helpPopup {
  position: fixed;
  inset: 0;
  top: 60px;
  display: flex;
  background: rgba(18, 18, 18, 0.4);
  z-index: 10;

  & > div {
    flex: 1;
    height: fit-content;
    margin: 16px 16px 32px;
    background: white;
    border-radius: 8px;
    position: relative;

    &::before {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 11px solid white;

      position: absolute;
      top: -10px;
      right: 66px;
    }

    .close {
      position: absolute;
      top: 16px;
      right: 16px;
    }
  }
}

.hide {
  display: none;
}
</style>
